import React from 'react';

const Error404 = () => (
  <div className="test">
    <div className="c">
      <div className="_404">404</div>
      <hr />
      <div className="_1">THE TRAIL</div>
      <div className="_2">WAS NOT FOUND</div>
      <a className="btn back-click" href="/">
        BACK TO HOME
      </a>
    </div>
  </div>
);

export default Error404;



// WEBPACK FOOTER //
// ./src/screens/404/Error404.jsx